import { z } from "zod";

/** One member post of an artist's fan club, as a member reads it. */
export const fanClubPostSchema = z.object({
  id: z.string().min(1),
  body: z.string().min(1),
  createdAt: z.string(),
  /** When its text was last changed; null when never. */
  editedAt: z.string().nullable(),
});

/**
 * A signed-in fan's read of an open club's member posts
 * (`GET /platform/link-pages/:artistSlug/club-posts`): a current member reads
 * them a page at a time, newest first; anyone else learns only how many
 * there are.
 */
export const artistLinkPageClubPostsSchema = z.discriminatedUnion("member", [
  z.object({
    member: z.literal(true),
    posts: z.array(fanClubPostSchema),
    /** The `before` of the next page; null on the last. */
    nextBefore: z.string().nullable(),
  }),
  z.object({
    member: z.literal(false),
    postCount: z.number().int().nonnegative(),
  }),
]);

export type FanClubPost = z.infer<typeof fanClubPostSchema>;
export type ArtistLinkPageClubPosts = z.infer<
  typeof artistLinkPageClubPostsSchema
>;

/**
 * Where a member post email's unsubscribe link points, under Platform API's
 * public base (`/platform`): the page that stops email from the artist the
 * email was sent for (LIS-1180). The token is the link's only credential.
 */
export const emailUnsubscribePath = (token: string) =>
  `/email/unsubscribe/${encodeURIComponent(token)}`;
